import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { RootState } from '../../../store'
import { EngagementEvents, logCrmEvent } from '../../utils/crmEvents'
import { InputModal } from '../InputModal'
import { Card } from '../Card'
import { Button } from '../Button'
import './dormancy-modal.scss'
import { kycServices } from '../../../services'
import { showBanner } from '../../../global-state/banner-slice'

const DormancyAcknowledgementModal = () => {
  const dispatch = useDispatch()
  const { authToken, userId, name, accountStatus } = useSelector(
    (state: RootState) => state.investor,
  )
  const [showModal, setShowModal] = useState(false)

  useEffect(() => {
    if (authToken && accountStatus === 'DORMANT') {
      const getInvestorKYC = async () => {
        const kycDetails = await kycServices.getKYC_v1(userId, {
          Authorization: authToken,
        })
        if (kycDetails?.status === 200) {
          if (!kycDetails?.data?.metadata?.dormancyAcknowledgement) {
            setShowModal(true)
          } else {
            setShowModal(false)
          }
        }
      }

      getInvestorKYC()
    }
  }, [authToken, dispatch])

  const handleButtonClick = async () => {
    const data = await kycServices.acceptDormancyAcknowledgment(
      { declaration: true },
      {
        Authorization: authToken ? authToken : '',
      },
    )

    if (data && data.data && data.status === 200) {
      logCrmEvent(
        EngagementEvents.VIEWED_ACCEPTED_DORMANCY_NOTIFICATION,
        {
          Authorization: authToken ?? '',
        },
        {
          userId,
          userName: name,
          accountStatus,
        },
      )

      setTimeout(() => {
        setShowModal(false)

        dispatch(
          showBanner({
            text: 'The Support team has been notified. We will get back to you soon.',
            variant: 'success-banner',
            duration: 5000,
          }),
        )
      }, 1000)
    }
  }

  return showModal ? (
    <InputModal testId='dormancy-acknowledgement-modal'>
      <div
        data-testid='dormancy-acknowledgement-modal-card-container'
        className='modal-card-container'
      >
        <Card classes={['p-24 dormancy-acknowledgement-modal']}>
          <div
            className='self-declaration-wrapper self-declaration-wrapper-overflow '
            style={{ maxHeight: 'calc(100% - 110px)' }}
          >
            <div className='self-declaration-wrapper-text'>
              <h1 className='text-align-center mb-24' style={{ lineHeight: '120%' }}>
                Your Account Has Been Marked as Dormant
              </h1>
              <p>
                Your account has been marked as dormant due to inactivity. If you believe this is an
                error or if you would like to reactivate your account, please contact our support
                team for assistance.
              </p>
              <br />

              <Button
                text={'Send email to support'}
                variant='primary-btn'
                handleClick={handleButtonClick}
              />
            </div>
          </div>
        </Card>
      </div>
    </InputModal>
  ) : null
}
export { DormancyAcknowledgementModal }
